import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AlertsBadge from '#/transit-tracker/components/AlertsBadge';
import * as Styled from './styled';

function RouteServiceAlertsPreview({
  routeAlerts,
  navigateToRouteAlerts,
  navigateToRouteAlertsEmail,
  routeIsShuttle,
}) {
  return (
    <Styled.AlertsPreviewWrapper>
      <Styled.AlertsPreviewTitleButton onClick={navigateToRouteAlerts}>
        <AlertsBadge text={routeAlerts.length.toString()} />
        <Styled.AlertsPreviewTitleColumn>
          <FormattedMessage
            id={`alerts.${
              routeAlerts.length === 1 ? 'previewtitlesingular' : 'previewtitle'
            }`}
          />
        </Styled.AlertsPreviewTitleColumn>
      </Styled.AlertsPreviewTitleButton>
      {!routeIsShuttle && (
        <Styled.AlertsPreviewEmailButton onClick={navigateToRouteAlertsEmail}>
          <Styled.AlertsPreviewEmailButtonIcon>
            <Styled.EmailIcon />
          </Styled.AlertsPreviewEmailButtonIcon>
          <Styled.AlertsPreviewEmailButtonText>
            <FormattedMessage id="alerts.updatesbyemail" />
          </Styled.AlertsPreviewEmailButtonText>
        </Styled.AlertsPreviewEmailButton>
      )}
    </Styled.AlertsPreviewWrapper>
  );
}

RouteServiceAlertsPreview.propTypes = {
  /** Collection of service alerts */
  routeAlerts: PropTypes.arrayOf(PropTypes.shape({})),
  /** Called when the user clicks the collection of service alerts */
  navigateToRouteAlerts: PropTypes.func.isRequired,
  /** Called when the user click the email button */
  navigateToRouteAlertsEmail: PropTypes.func.isRequired,
  /** If the route is a shuttle, email signups aren't available */
  routeIsShuttle: PropTypes.bool.isRequired,
};

RouteServiceAlertsPreview.defaultProps = {
  routeAlerts: [],
};

export default RouteServiceAlertsPreview;
